import { render } from "./KutipanSemasa.vue?vue&type=template&id=025b8b71"
import script from "./KutipanSemasa.vue?vue&type=script&lang=js"
export * from "./KutipanSemasa.vue?vue&type=script&lang=js"

import "./KutipanSemasa.vue?vue&type=style&index=0&id=025b8b71&lang=css"
import "./KutipanSemasa.vue?vue&type=style&index=1&id=025b8b71&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__